import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface RebateCalculationMethodFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const RebateCalculationMethodFilter: React.FC<RebateCalculationMethodFilterProps> = (
  props
) => {
  const { filter, onFilterChange } = props
  const rebateCalcMethods = useAppSelector((state) => state.partnerships.rebateCalcMethods)

  const data = rebateCalcMethods.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Instrument Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
